import decodeJwt from 'jwt-decode';
import { toUpper } from 'lodash';
import { DEFAULT_API_CONFIG } from './apiConfig';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/orders/ssolink`;

export const getRedirect = async data => {
  const headers = getHeaders();
  const requestOptions = {
    method: 'GET',
    headers
  };

  var route = `${baseRoute}?id=${data?.id}&type=${data?.type}`

  const response = await fetch(route, requestOptions);
console.log({response});
  return response.ok ? await response.json() : Promise.reject(response);
};
